import { writable } from 'svelte/store';

export const Policy = writable({});
export const User = writable(null);
export const Language = writable(localStorage.getItem('language') || 'en');

// Subscribe to persist language preference
Language.subscribe(value => {
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('language', value);
    }
});
